module.exports = __webpack_public_path__ + "img/sha_04.6872ef60.jpg";